const AdminRoutes = {
  Root: "/admin",
  Dashboard: "/admin/dashboard",
  LogIn: "/admin/login",
  DemandResponse: "/admin/demand-response",
  ChargingLocationSubmeter: "/admin/charging-location-submeter",
}

export default AdminRoutes;